import route from 'ziggy-js';

/**
 * @param {String} name 後端路由名稱
 * @see 後端路由名稱表請參照: config/ziggy.php
 */
const ziggyRoute = (props, name, params, absolute) => route(
    name,
    params,
    absolute,
    props.ziggyConfig
);

export default ziggyRoute;
